import styled, { css } from 'styled-components';
import { Link as LinkComponent } from 'react-router-dom';
import { layout } from '@prisjakt/ui-base';

const BRAND_LOGO_WIDTH = 88;
const BRAND_LOGO_HEIGHT = 31;

export const RecommendedRetailerExpansion = styled.div(
  props => css`
    color: ${props.theme.text.secondary};
    display: inline-flex;
    flex-direction: column;
    margin-bottom: ${layout.measurements.spacing100};
  `
);

export const LogoWrapper = styled(LinkComponent)`
  align-self: flex-start;
`;

export const Logo = styled.img`
  margin-top: ${layout.measurements.spacing050};
  width: ${BRAND_LOGO_WIDTH}px;
  height: ${BRAND_LOGO_HEIGHT}px;
`;

export const IconAndTextWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${layout.measurements.spacing025};
  margin-left: -${layout.measurements.spacing025};
`;

export const Text = styled.p`
  margin: 0;
`;
